import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pages"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "btn"
}
const _hoisted_4 = {
  key: 1,
  class: "btn"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = { class: "inputName input-card" }
const _hoisted_11 = { class: "form-item" }
const _hoisted_12 = { class: "inputName" }
const _hoisted_13 = { class: "upload-card" }
const _hoisted_14 = { class: "upload-icon" }
const _hoisted_15 = {
  key: 1,
  class: "upload-grid"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "form-item" }
const _hoisted_19 = { class: "inputName" }
const _hoisted_20 = { class: "custom-node" }
const _hoisted_21 = { class: "form-item" }
const _hoisted_22 = { class: "inputName" }
const _hoisted_23 = { class: "form-item" }
const _hoisted_24 = { class: "inputName" }
const _hoisted_25 = { class: "form-item" }
const _hoisted_26 = { class: "inputName" }
const _hoisted_27 = { class: "action-bar" }
const _hoisted_28 = { class: "right" }
const _hoisted_29 = {
  key: 0,
  class: "flex w-full items-center justify-center h-full flex-col"
}
const _hoisted_30 = { style: {"padding":"12px","word-break":"break-all","white-space":"pre-wrap"} }
const _hoisted_31 = { style: {"display":"flex","justify-content":"flex-end","gap":"10px","padding":"0 8px"} }

import { ref, onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { PictureFilled, Close } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { getMatchCategory, uploadImage, createMatch, checkRole, getBusinessApplyStatus } from '@/api/match'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
//@ts-ignore
import result from '@/views/match/result.vue'
//@ts-ignore
import MerchantImageDialog from './MerchantImageDialog.vue'
//@ts-ignore
import DesignerApplyDialog from './DesignerApplyDialog.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'match',
  setup(__props) {

const matchIng = ref('none')
const textarea2 = ref('')
const pageShow = ref(false)
onMounted(() => {
    if (route.query.token) {
        localStorage.setItem('matchToken', route.query.token as string)
        window.location.replace('/match')
        // matchOrderId.value = route.query.token as string
    } else if (localStorage.getItem('matchToken')) {
        pageShow.value = true
    } else {
        ElMessage.error('请先登录')
    }
    // if (route.query.token) {
    //     loca
    //     pageShow.value = false
    // }

    getmatchCategoryOpt()
    getRoleOpt()
    getUserOpt()
})
const sceneValue = ref([])
const cascaderProps = { checkStrictly: true, label: 'name', value: 'id' }
const sceneOptions = ref([])
const budgetValue = ref('')
const budgetOptions = ref([])
const styleValue = ref([])
const styleOptions = ref([])
const themeValue = ref([])
const themeOptions = ref([])
const showMerchantDialog = ref(false)
const merchantImageSrc = ref('https://via.placeholder.com/760x520.png?text=%E5%95%86%E5%AE%B6%E5%85%A5%E9%A9%BB%E7%94%B3%E8%AF%B7')
const showDesignerDialog = ref(false)
const showFailDialog = ref(false)
const inspireUploadRef = ref()
const inspireList = ref<Array<{ url: string, name: string, uid?: string | number, raw: File }>>([])
const beforeInspireUpload = (file: File) => {
    const okType = (file.type && file.type.startsWith('image/')) || /\.(png|jpe?g|png|webp|gif|bmp|svg)$/i.test(file.name || '')
    if (!okType) { ElMessage.error('仅支持图片格式'); return false }
    if (inspireList.value.length >= 9) { ElMessage.warning('最多选择 9 张'); return false }
    return true
}
const dummyUpload = (option: any) => { setTimeout(() => { option.onSuccess({}, option.file) }, 300) }
const onInspireSuccess = (_: any, file: any) => {
    const raw: File = file?.raw || file
    if (!raw) return
    const uid = file?.uid || raw.name
    if (inspireList.value.find(f => f.uid === uid || f.name === raw.name)) return
    const url = file?.url || URL.createObjectURL(raw)
    inspireList.value.push({ url, name: raw.name, uid, raw })
}
const onInspireExceed = () => { ElMessage.warning('最多选择 9 张') }
const removeInspire = (idx: number) => {
    const it = inspireList.value[idx]
    if (!it) return
    try { if (it.url && String(it.url).startsWith('blob:')) URL.revokeObjectURL(it.url) } catch { }
    inspireList.value.splice(idx, 1)
}
const onAddInspire = () => {
    try {
        const input = inspireUploadRef.value?.$el?.querySelector('input[type=file]')
        input && input.click()
    } catch { }
}
const getmatchCategoryOpt = async () => {
    const res = await getMatchCategory({})
    //@ts-ignore
    if (res.data?.code === 200) {
        sceneOptions.value = res.data.data.categories
        sceneOptions.value = res.data.data.categories as any
        budgetOptions.value = res.data.data.budgetLevels as any
        styleOptions.value = res.data.data.styles as any
        themeOptions.value = res.data.data.themes as any
    }


}
const matchOrderId = ref('')
const route = useRoute()
const planValue = ref({})
const onGenDesign = async () => {
    if (textarea2.value == '') {
        ElMessage.error('请输入设计需求')
        return
    }
    matchIng.value = 'loading'
    // console.log(inspireList.value)
    let uploadUrls: string[] = []
    for (var i = 0; i < inspireList.value.length; i++) {
        const formData = new FormData()
        formData.append('file', inspireList.value[i].raw)
        const res = await uploadImage(formData)

        uploadUrls.push(res.data.data.url)
    }
    console.log(uploadUrls)
    // const formData = new FormData()
    // formData.append('file', inspireList.value[0].raw)
    // const res = await uploadImage(formData)
    // console.log(res.data.data)
    // if (res.data?.code === 200) {
    //     loading.hide()
    //     ElMessage.success('上传成功')
    // } else {
    //     loading.hide()
    //     ElMessage.error(res.data?.msg || '上传失败')
    // }
    const orderId = String((route.query as any).match_order_id || (route.query as any).orderid || '')
    let params = {
        match_order_id: orderId,
        demand: textarea2.value,
        cid: sceneValue.value.join(','),
        budgetLevels: budgetValue.value,
        styles: styleValue.value.join(','),
        themes: themeValue.value.join(','),
        inspire: uploadUrls.join(',')
    }
    const res = await createMatch(params)
    if (res.data?.code === 200) {
        matchIng.value = 'success'
        planValue.value = res.data.data
        // matchOrderId.value = res.data.data.match_order_id
    } else {
        matchIng.value = 'none'
        ElMessage.error(res.data?.msg || '生成失败')
    }
}
const roleOptions = ref('')
const getRoleOpt = async () => {
    const res = await checkRole({})
    //@ts-ignore
    if (res.data?.code === 200) {
        roleOptions.value = res.data.data
    }
}
const certificationOptions = ref({})
const getUserOpt = async () => {
    const res = await getBusinessApplyStatus({ origin_type: 2 })
    //@ts-ignore
    if (res.data?.code === 200) {
        certificationOptions.value = res.data.data
    }
}
const openApplyDialog = (val) => {
    showFailDialog.value = false
    if (val == 3) {
        showDesignerDialog.value = true
    } else {
        showMerchantDialog.value = true

    }
    // showApplyDialog.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (pageShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "header-title" }, "智能场景匹配", -1)),
          (roleOptions.value == 9 && certificationOptions.value.audit_status == -1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showMerchantDialog.value = true))
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("入驻商家", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDesignerDialog.value = true))
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("成为设计师", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (roleOptions.value == 9 && certificationOptions.value.audit_status == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_el_button, { type: "warning" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(certificationOptions.value.user_type == 1 ? '商家' : '设计师') + "认证审核......", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (roleOptions.value == 9 && certificationOptions.value.audit_status == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode("已认证" + _toDisplayString(certificationOptions.value.user_type == 1 ? '商家' : '设计师') + "已通过", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (roleOptions.value == 9 && certificationOptions.value.audit_status == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "danger",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showFailDialog.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("已认证" + _toDisplayString(certificationOptions.value.user_type == 1 ?
                    '商家' : '设计师') + "认证未通过", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "panel-title" }, "请描述您的派对需求", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_input, {
                  modelValue: textarea2.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((textarea2).value = $event)),
                  resize: "none",
                  style: {"width":"100%"},
                  type: "textarea",
                  rows: 5,
                  placeholder: "例如：想办一个森系风格的生日派对，预算2000左右，大概20人，希望有很多绿植和自然元素，氛围温馨浪漫..."
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "item-title" }, "上传灵感图片（可选，支持多张）", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_upload, {
                  ref_key: "inspireUploadRef",
                  ref: inspireUploadRef,
                  class: "uploader",
                  drag: "",
                  "show-file-list": false,
                  multiple: "",
                  accept: "image/*",
                  limit: 9,
                  "on-exceed": onInspireExceed,
                  "before-upload": beforeInspireUpload,
                  "http-request": dummyUpload,
                  "on-success": onInspireSuccess
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      (inspireList.value.length === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PictureFilled))
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "upload-text-main" }, "点击选择图片", -1)),
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "upload-text-sub" }, "支持 JPG、PNG，最多 9 张", -1))
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inspireList.value, (f, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: f.uid || idx,
                                class: "works-item"
                              }, [
                                _createElementVNode("img", {
                                  src: f.url,
                                  class: "works-img"
                                }, null, 8, _hoisted_16),
                                _createElementVNode("div", {
                                  class: "remove-btn",
                                  title: "删除",
                                  onClick: _withModifiers(($event: any) => (removeInspire(idx)), ["stop"])
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Close))
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_17)
                              ]))
                            }), 128)),
                            (inspireList.value.length < 9)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "works-item",
                                  onClick: onAddInspire
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PictureFilled))
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ])
                  ]),
                  _: 1
                }, 512)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "item-title" }, "场景类型", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_cascader, {
                  style: {"width":"100%"},
                  modelValue: sceneValue.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sceneValue).value = $event)),
                  options: sceneOptions.value,
                  props: cascaderProps,
                  class: "full"
                }, {
                  default: _withCtx(({ node, data }) => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(data.name), 1),
                      _createElementVNode("span", null, _toDisplayString(node.level), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "item-title" }, "预算范围", -1)),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_select, {
                  modelValue: budgetValue.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((budgetValue).value = $event)),
                  placeholder: "请选择预算",
                  class: "full"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budgetOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.value,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "item-title" }, "风格偏好", -1)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_select, {
                  modelValue: styleValue.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((styleValue).value = $event)),
                  multiple: "",
                  placeholder: "请选择风格",
                  class: "full"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(styleOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.value,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "item-title" }, "主题偏好", -1)),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_select, {
                  modelValue: themeValue.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((themeValue).value = $event)),
                  multiple: "",
                  placeholder: "请选择主题",
                  class: "full"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.value,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_button, {
                type: "primary",
                class: "gen-btn",
                onClick: onGenDesign
              }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createTextVNode("智能生成设计", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            (matchIng.value === 'none')
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("div", { class: "loading-title" }, "智能生成设计", -1),
                  _createElementVNode("div", { class: "loading-subtitle" }, "在左侧内容区输入你的创意吧", -1)
                ]))]))
              : _createCommentVNode("", true),
            (matchIng.value === 'loading')
              ? (_openBlock(), _createBlock(NewLoading, { key: 1 }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("div", { class: "loading-title" }, "AI 正在分析您的需求...", -1),
                    _createElementVNode("div", { class: "loading-subtitle" }, "正在分析需求...", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(result, {
              plan: planValue.value,
              usertype: roleOptions.value
            }, null, 8, ["plan", "usertype"]), [
              [_vShow, matchIng.value === 'success']
            ])
          ])
        ]),
        _createVNode(MerchantImageDialog, {
          visible: showMerchantDialog.value,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((showMerchantDialog).value = $event)),
          "image-src": merchantImageSrc.value
        }, null, 8, ["visible", "image-src"]),
        _createVNode(DesignerApplyDialog, {
          visible: showDesignerDialog.value,
          "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((showDesignerDialog).value = $event))
        }, null, 8, ["visible"]),
        _createVNode(_component_el_dialog, {
          modelValue: showFailDialog.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showFailDialog).value = $event)),
          title: "认证失败原因",
          width: "420px",
          "align-center": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_el_button, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (showFailDialog.value = false))
              }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode("关闭", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (openApplyDialog(certificationOptions.value.user_type)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(certificationOptions.value.user_type == 1 ?
                            '重新提交商家申请' : '重新提交设计师申请'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (openApplyDialog(certificationOptions.value.user_type == 1 ? 3 : 1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(certificationOptions.value.user_type == 1 ?
                            '入驻设计师'
                            : '入驻设商家'), 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_30, _toDisplayString(certificationOptions.value.remark ||
                '暂无失败原因'), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})